import type { LocalizedStrings as LocalizedStringsType } from "localized-strings";

import { initializeLocalizationCrossPlatform } from "./base";
import type { LanguageStrings } from "./types";

export async function initializeLocalization(language: string): Promise<LocalizedStringsType<LanguageStrings>> {
    return initializeLocalizationCrossPlatform(language);
}
